import React, { useMemo, useState } from "react";
import {
  Bus,
  Home,
  ArrowLeftRight,
  Navigation,
  TrendingUp,
  Percent,
  LogOut,
  Clock,
  Megaphone,
  Sparkles,
  Crown,
  CheckCircle2,
  PlusCircle,
  Lock,
  Unlock,
  Search,
  Menu,
  X,
  Loader2,
  Building2,
  Phone,
  MessageCircle,
  MapPin,
  Edit3,
  Trash2
} from "lucide-react";
import { db, auth } from "../config/firebase";
import {
  addDoc,
  collection,
  serverTimestamp,
  writeBatch,
  doc,
  deleteDoc,
} from "firebase/firestore";

import CityAutocomplete from "../components/CityAutocomplete";
/**
* RouteRegistrationView
* UI puro (sem lógica de Firestore). Recebe tudo via props.
*/
export default function RouteRegistrationView(props) {
const {
adDurationDays,
adImagePreview,
adLinkDestino,
adModalOpen,
adPlacement,
adPlan,
adSubmitting,
MAX_AD_IMAGES,
MAX_AD_IMAGE_MB,
ACCEPTED_AD_IMAGE_TYPES,
addCidades,
aplicarPercentualIndividual,
createCustomPoint,
destCompanyPhone,
destination,
distance,
driverPhone,
editingId,
embarkFeeValue,
fareOverrides,
globalPercent,
goToHome,
handleCancelAdRequest,
handleRemoveOverride,
handleSave,
handleSaveOverride,
handleSwapRoute,
hasEmbarkFee,
individualPercent,
isCalculating,
map,
mapRef,
myAdRequests,
myReqFilter,
myRoutes,
navigate,
normalizePoint,
novoPontoNome,
novoPontoUF,
openAdModal,
origin,
originCompanyPhone,
outTime,
ovCityA,
ovCityB,
ovPrice,
price,
pricingConfigs,
pricingMode,
returnTime,
salvandoPonto,
savedRouteId,
selectedRouteData,
setAdDurationDays,
setAdImageFile,
setAdImagePreview,
setAdLinkDestino,
setAdModalOpen,
setAdPlacement,
setAdPlan,
setAddCidades,
setDestCompanyPhone,
setDestination,
setDriverPhone,
setEditingId,
setEmbarkFeeValue,
setGlobalPercent,
setHasEmbarkFee,
setIndividualPercent,
setIsCalculating,
setMyReqFilter,
setNovoPontoNome,
setNovoPontoUF,
setOrigin,
setOriginCompanyPhone,
setOutTime,
setOvCityA,
setOvCityB,
setOvPrice,
setPrice,
setPricingConfigs,
setPricingMode,
setReturnTime,
setSalvandoPonto,
setShowReajusteGlobal,
setShowReajusteKm,
setShowTrechos,
setUnlockAddCidade,
showReajusteGlobal,
showReajusteKm,
showTrechos,
submitAdRequest,
unlockAddCidade,
verificarSenha
} = props;
return (
<div className="admin-container">
<header className="home-header">
  <div className="header-container">

    <div className="logo-section" onClick={goToHome} style={{ cursor: "pointer" }}>
      <Bus size={32} color="#6366f1" />
      <h1>ACHEVAM</h1>
    </div>

    <div
      className="nav-links"
      style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}
    >
      {/* INÍCIO */}
      <button
        type="button"
        className="btn-ghost"
        onClick={goToHome}
        title="Início"
      >
        <Home size={18} /> Início
      </button>

      {/* TRECHOS */}
      <button
        type="button"
        className={`btn-ghost ${showTrechos ? "active" : ""}`}
        onClick={() => setShowTrechos(v => !v)}
        title="Correção por trecho"
      >
        <ArrowLeftRight size={18} /> Trechos
      </button>

      {/* REAJUSTE KM */}
      <button
        type="button"
        className={`btn-ghost ${showReajusteKm ? "active" : ""}`}
        onClick={() => setShowReajusteKm(v => !v)}
        title="Reajuste por KM"
      >
        <TrendingUp size={18} /> Reajuste KM
      </button>

      {/* REAJUSTE GLOBAL */}
      <button
        type="button"
        className={`btn-ghost ${showReajusteGlobal ? "active" : ""}`}
        onClick={() => setShowReajusteGlobal(v => !v)}
        title="Reajuste global"
      >
        <Percent size={18} /> Reajuste %
      </button>

      {/* SAIR */}
      <button
        type="button"
        className="btn-ghost"
        onClick={async () => {
          try {
            await auth.signOut();
          } finally {
            navigate("/login");
          }
        }}
        title="Sair"
      >
        <LogOut size={18} /> Sair
      </button>

    </div>
  </div>
</header>

<main className="admin-main">
{/* COLUNA ESQUERDA */}
<div className="admin-column">
<form onSubmit={handleSave} className="modern-card animate-in" style={{ padding: 18 }}>
<h2 className="card-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
<Navigation size={20} color="#6366f1" /> Cadastro de Rotas
</h2>
<div className="input-grid" style={{ marginTop: 12 }}>
<div className="input-group">
<label>Origem</label>
<CityAutocomplete value={origin} onChange={setOrigin} placeholder="Ex: Palmas-TO"
extraItems={addCidades}
strict={true}
enableUnlock={true}
onCreateCustom={createCustomPoint}
/>
</div>
<div className="input-group">
<label>Destino</label>
<CityAutocomplete value={destination} onChange={setDestination} placeholder="Ex: Araguaína-TO"
extraItems={addCidades}
strict={true}
enableUnlock={true}
onCreateCustom={createCustomPoint}
/>
</div>
<div className="input-group" style={{ display: "flex", alignItems: "flex-end" }}>
<button
type="button"
onClick={handleSwapRoute}
style={{
width: "100%",
height: 44,
borderRadius: 12,
border: "1px solid rgba(148,163,184,.35)",
background: "#fff",
fontWeight: 950,
cursor: "pointer",
}}
title="Inverter origem/destino"
>
<ArrowLeftRight size={18} /> Inverter
</button>
</div>
</div>
<div className="input-grid" style={{ marginTop: 12 }}>
<div className="input-group">
<label>Horário de saída</label>
<input type="time" value={outTime} onChange={(e) => setOutTime(e.target.value)} required />
</div>
<div className="input-group">
<label>Horário de retorno</label>
<input type="time" value={returnTime} onChange={(e) => setReturnTime(e.target.value)} required />
</div>
<div className="input-group">
<label>Modo de preço</label>
<div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
<label style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 900 }}>
<input type="radio" checked={pricingMode === "auto"} onChange={() => setPricingMode("auto")} />
Automático (KM)
</label>
<label style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 900 }}>
<input type="radio" checked={pricingMode === "manual"} onChange={() => setPricingMode("manual")} />
Manual
</label>
</div>
</div>
</div>
{pricingMode === "auto" ? (
<div className="input-grid" style={{ marginTop: 12 }}>
<div className="input-group">
<label>Valor por KM</label>
<input
type="number"
step="0.10"
value={pricingConfigs.valorPorKm}
onChange={(e) => setPricingConfigs({ ...pricingConfigs, valorPorKm: e.target.value })}
placeholder="Ex: 0.45"
/>
</div>
<div className="input-group">
<label>Taxa fixa</label>
<input
type="number"
value={pricingConfigs.taxaFixa}
onChange={(e) => setPricingConfigs({ ...pricingConfigs, taxaFixa: e.target.value })}
placeholder="Ex: 5"
/>
</div>
</div>
) : null}
<div className="modern-card" style={{ marginTop: 14 }}>
<div style={{ fontWeight: 950, marginBottom: 8 }}>Mapa (rota)</div>
<div
ref={mapRef}
style={{
height: 260,
borderRadius: 14,
border: "1px solid rgba(148,163,184,.28)",
background: "#eef2ff",
}}
/>
<div style={{ marginTop: 8, fontSize: 12, color: "#64748b", fontWeight: 800 }}>
{selectedRouteData?.distance ? (
<>
Distância estimada: <b>{selectedRouteData.distance}</b> km
</>
) : (
<>Preencha origem/destino para desenhar a rota.</>
)}
</div>
</div>
{/* ==========================
ADD CIDADES (PONTO ESPECÍFICO)
- Só habilita depois que a rota estiver salva
========================== */}
<div className="modern-card" style={{ marginTop: 14, borderLeft: "4px solid #6366f1" }}>
<div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}>
<MapPin size={18} color="#6366f1" />
Adicionar ponto específico na rota
</div>
<div style={{ color: "#64748b", fontWeight: 800, fontSize: 13, marginTop: 6 }}>
Use isso para cadastrar <b>povoados</b>, <b>trevos</b> e pontos famosos que não existem no IBGE.
Eles aparecem no autocomplete do app inteiro (Home) e também no cadastro de rotas.
</div>
<div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
<button
type="button"
className="btn-ghost"
onClick={() => {
if (!editingId && !savedRouteId) {
alert("Primeiro salve a rota principal. Depois você adiciona pontos específicos.");
return;
}
setUnlockAddCidade((v) => !v);
}}
style={{
height: 42,
padding: "0 12px",
borderRadius: 12,
border: "1px solid rgba(148,163,184,.35)",
background: unlockAddCidade ? "rgba(99,102,241,.10)" : "#fff",
fontWeight: 950,
cursor: "pointer",
display: "inline-flex",
alignItems: "center",
gap: 8,
}}
title="Desbloquear para adicionar ponto"
>
{unlockAddCidade ? "🔓 Desbloqueado" : "🔒 Bloqueado"} • Add ponto
</button>
</div>
{unlockAddCidade && (
<div style={{ marginTop: 12 }}>
<div className="input-grid">
<div className="input-group">
<label>Nome do ponto</label>
<input
value={novoPontoNome}
onChange={(e) => setNovoPontoNome(e.target.value)}
placeholder="Ex: Trevo da BR-153"
/>
</div>
<div className="input-group">
<label>UF</label>
<input
value={novoPontoUF}
onChange={(e) => setNovoPontoUF(e.target.value)}
placeholder="Ex: TO"
maxLength={2}
/>
</div>
</div>
<div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
<button
type="button"
className="btn-main"
disabled={salvandoPonto}
onClick={async () => {
const nome = String(novoPontoNome || "").trim();
const uf = String(novoPontoUF || "").trim().toUpperCase();
if (nome.length < 2) return alert("Digite um nome válido para o ponto.");
if (uf.length !== 2) return alert("Digite uma UF válida (2 letras).");
const label = `${nome} - ${uf}`;
setSalvandoPonto(true);
try {
await addDoc(collection(db, "addCidades"), {
label,
norm: normalizePoint(label),
nome,
uf,
createdAt: serverTimestamp(),
createdBy: auth.currentUser?.uid || null,
source: "company",
routeId: editingId || savedRouteId,
});
// atualiza lista local (para aparecer instantâneo)
setAddCidades((prev) => {
const s = new Set((prev || []).map((x) => String(x).trim().toLowerCase()));
if (s.has(label.toLowerCase())) return prev || [];
return [...(prev || []), label].sort((a, b) => a.localeCompare(b, "pt-BR"));
});
setNovoPontoNome("");
setNovoPontoUF("");
setUnlockAddCidade(false);
alert("Ponto salvo! Ele já aparece no autocomplete.");
} catch (e) {
console.error(e);
alert("Não foi possível salvar o ponto. Verifique as regras do Firestore.");
} finally {
setSalvandoPonto(false);
}
}}
style={{ width: "auto", height: 44, padding: "0 14px" }}
>
{salvandoPonto ? "Salvando..." : "Salvar ponto"}
</button>
</div>
</div>
)}
</div>
{showTrechos && (
<div style={{ marginTop: 18, padding: 14, border: "1px solid rgba(148,163,184,.28)", borderRadius: 14, background: "#f8fafc" }}>
<div style={{ fontWeight: 950, marginBottom: 10 }}>Correção por trecho (global da empresa)</div>
<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 180px", gap: 10, alignItems: "end" }}>
<div>
<label style={{ display: "block", fontSize: 12, fontWeight: 900, color: "#475569", marginBottom: 6 }}>Cidade A</label>
<CityAutocomplete value={ovCityA} onChange={setOvCityA} placeholder="Ex: Nova Olinda-TO"
extraItems={addCidades}
strict={true}
enableUnlock={true}
onCreateCustom={createCustomPoint}
/>
</div>
<div>
<label style={{ display: "block", fontSize: 12, fontWeight: 900, color: "#475569", marginBottom: 6 }}>Cidade B</label>
<CityAutocomplete value={ovCityB} onChange={setOvCityB} placeholder="Ex: Palmas-TO"
extraItems={addCidades}
strict={true}
enableUnlock={true}
onCreateCustom={createCustomPoint}
/>
</div>
<div>
<label style={{ display: "block", fontSize: 12, fontWeight: 900, color: "#475569", marginBottom: 6 }}>Preço do trecho</label>
<input
value={ovPrice}
onChange={(e) => setOvPrice(e.target.value)}
placeholder="Ex: 35,00"
style={{
width: "100%",
height: 44,
borderRadius: 12,
border: "1px solid rgba(148,163,184,.35)",
padding: "0 12px",
fontWeight: 900,
}}
/>
</div>
</div>
<div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
<button
type="button"
onClick={handleSaveOverride}
style={{
background: "#10b981",
color: "#fff",
border: "none",
borderRadius: 12,
padding: "10px 14px",
fontWeight: 950,
cursor: "pointer",
boxShadow: "0 10px 22px rgba(16,185,129,.18)",
}}
>
Salvar correção (empresa)
</button>
</div>
<div style={{ fontSize: 12, marginTop: 10, color: "#64748b", fontWeight: 800 }}>
Essa correção vale para <b>todas</b> as rotas da empresa que passarem por este trecho.
</div>
<div style={{ marginTop: 12 }}>
<div style={{ fontWeight: 900, marginBottom: 8 }}>Correções cadastradas</div>
{!fareOverrides || Object.keys(fareOverrides).length === 0 ? (
<div style={{ color: "#64748b", fontWeight: 800 }}>Nenhuma correção por trecho ainda.</div>
) : (
<div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
{Object.entries(fareOverrides).map(([k, v]) => (
<div
key={k}
style={{
display: "flex",
alignItems: "center",
justifyContent: "space-between",
gap: 10,
padding: 10,
border: "1px solid rgba(148,163,184,.35)",
borderRadius: 12,
}}
>
<div style={{ fontWeight: 900 }}>
{k} <span style={{ color: "#64748b", fontWeight: 800 }}>→</span> R$ {Number(v || 0).toFixed(2)}
</div>
<button
type="button"
onClick={() => handleRemoveOverride(k)}
style={{
background: "#fee2e2",
color: "#991b1b",
border: "1px solid rgba(239,68,68,.35)",
borderRadius: 10,
padding: "8px 10px",
fontWeight: 900,
cursor: "pointer",
}}
>
Remover
</button>
</div>
))}
</div>
)}
</div>
</div>
)}
{/* PREÇO + REAJUSTE INDIVIDUAL */}
<div className="input-grid" style={{ marginTop: 15 }}>
<div className="input-group">
<label style={{ color: pricingMode === "manual" ? "#6366f1" : "#666", fontWeight: "bold" }}>
Preço da rota (R$) <span style={{ color: "#64748b", fontWeight: 800 }}>(sem taxa de embarque)</span>
</label>
<input
type="number"
value={price}
onChange={(e) => {
setPrice(e.target.value);
setPricingMode("manual");
}}
placeholder="0.00"
style={{ border: pricingMode === "manual" ? "2px solid #6366f1" : "1px solid #ddd" }}
/>
</div>
{showReajusteGlobal || showReajusteKm || showTrechos ? (
<div className="input-group">
<label>
<Percent size={12} /> Reajustar esta rota (%)
</label>
<div style={{ display: "flex", gap: 6 }}>
<input
type="number"
placeholder="Ex: 10 ou -5"
value={individualPercent}
onChange={(e) => setIndividualPercent(e.target.value)}
/>
<button
type="button"
onClick={aplicarPercentualIndividual}
style={{
background: "#6366f1",
color: "#fff",
border: "none",
borderRadius: 10,
padding: "0 12px",
fontWeight: 900,
cursor: "pointer",
}}
>
OK
</button>
</div>
<small>Isso ajusta o preço digitado acima.</small>
</div>
) : null}
</div>
{/* TAXA DE EMBARQUE */}
<div className="modern-card" style={{ marginTop: 14, borderLeft: "4px solid #0ea5e9" }}>
<div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}>
<Clock size={18} color="#0ea5e9" />
Taxa de embarque (opcional)
</div>
<div style={{ color: "#64748b", fontWeight: 800, fontSize: 13, marginTop: 6 }}>
Se sua van cobra uma taxa fixa quando o passageiro embarca no terminal/rodoviária,
ative aqui e informe o valor. O app soma essa taxa ao preço proporcional quando a busca começar
na cidade de origem desta rota.
</div>
<div className="input-grid" style={{ marginTop: 12 }}>
<div className="input-group">
<label style={{ display: "flex", alignItems: "center", gap: 8 }}>
<input
type="checkbox"
checked={hasEmbarkFee}
onChange={(e) => setHasEmbarkFee(e.target.checked)}
style={{ width: 18, height: 18 }}
/>
Tem taxa de embarque?
</label>
</div>
<div className="input-group">
<label>Valor da taxa (R$)</label>
<input
type="number"
step="0.01"
value={embarkFeeValue}
onChange={(e) => setEmbarkFeeValue(e.target.value)}
placeholder="Ex: 5"
disabled={!hasEmbarkFee}
/>
</div>
</div>
</div>
{/* TELEFONES */}
<div className="input-grid" style={{ marginTop: 15 }}>
<div className="input-group">
<label>Telefone do Motorista (WhatsApp)</label>
<input
type="text"
value={driverPhone}
onChange={(e) => setDriverPhone(e.target.value)}
required
placeholder="Ex: (63) 99999-9999"
/>
</div>
<div className="input-group">
<label>Telefone da Empresa (Origem) (opcional)</label>
<input
type="text"
value={originCompanyPhone}
onChange={(e) => setOriginCompanyPhone(e.target.value)}
placeholder="Ex: (63) 99999-9999"
/>
</div>
<div className="input-group">
<label>Telefone da Empresa (Destino) (opcional)</label>
<input
type="text"
value={destCompanyPhone}
onChange={(e) => setDestCompanyPhone(e.target.value)}
placeholder="Ex: (63) 99999-9999"
/>
</div>
</div>
<button type="submit" className="btn-main" style={{ marginTop: 20 }}>
{editingId ? "ATUALIZAR" : "SALVAR ROTA"}
</button>
</form>
{/* ---------------------------
ANÚNCIOS
--------------------------- */}
<div className="modern-card animate-in ad-offer-card">
<div className="ad-offer-head">
<div className="ad-offer-title">
<Megaphone size={20} color="#6366f1" />
<h2>Quer mais passageiros?</h2>
</div>
<p className="ad-offer-sub">
Cadastre rotas grátis. Se quiser aparecer nos banners do AcheVam, solicite um plano abaixo.
</p>
</div>
<div className="ad-plans-grid">
<button type="button" className="ad-plan ad-plan--destaque" onClick={() => openAdModal("destaque")}>
<div className="ad-plan-badge">
<Sparkles size={16} /> Destaque
</div>
<div className="ad-plan-price">R$ 99/mês</div>
<ul className="ad-plan-list">
<li>
<CheckCircle2 size={16} /> Mais visibilidade
</li>
<li>
<CheckCircle2 size={16} /> Aparece em espaços patrocinados
</li>
<li>
<CheckCircle2 size={16} /> Ideal para começar
</li>
</ul>
<div className="ad-plan-cta">Solicitar Destaque</div>
</button>
<button type="button" className="ad-plan ad-plan--premium" onClick={() => openAdModal("premium_rota")}>
<div className="ad-plan-badge">
<Crown size={16} /> Premium por rota
</div>
<div className="ad-plan-price">R$ 199/mês</div>
<ul className="ad-plan-list">
<li>
<CheckCircle2 size={16} /> Prioridade na busca
</li>
<li>
<CheckCircle2 size={16} /> Aparece para quem buscar sua rota
</li>
<li>
<CheckCircle2 size={16} /> Vagas limitadas por rota
</li>
</ul>
<div className="ad-plan-cta">Solicitar Premium</div>
</button>
</div>
<div className="ad-offer-foot">
<span className="ad-foot-pill">✅ Aprovação rápida</span>
<span className="ad-foot-pill">📈 Mais contatos no WhatsApp</span>
<span className="ad-foot-pill">🧾 Pagamento mensal</span>
</div>
{/* Minhas solicitações */}
<div className="modern-card animate-in ad-myreq-card">
<div className="ad-myreq-head">
<h3 className="ad-myreq-title">Minhas solicitações</h3>
<select className="ad-myreq-filter" value={myReqFilter} onChange={(e) => setMyReqFilter(e.target.value)}>
<option value="all">Todas</option>
<option value="pending">Pendentes</option>
<option value="approved">Aprovadas</option>
<option value="rejected">Rejeitadas</option>
<option value="cancelled">Canceladas</option>
</select>
</div>
<div className="ad-myreq-list">
{myAdRequests
.filter((r) => (myReqFilter === "all" ? true : String(r.status || "pending") === myReqFilter))
.map((r) => (
<div key={r.id} className="ad-myreq-item">
<div className="ad-myreq-left">
<div className="ad-myreq-line">
<span className={`ad-status ad-status--${String(r.status || "pending")}`}>
{String(r.status || "pending")}
</span>
<span className="ad-plan-chip">{r.plan === "premium_rota" ? "Premium por rota" : "Destaque"}</span>
<span className="ad-place-chip">{r.placement || ""}</span>
</div>
{r.targetType === "route" && (
<div className="ad-myreq-sub">
Rota: {r.targetOrigin || ""} → {r.targetDestination || ""}
</div>
)}
{!!r.bannerImageUrl && (
<a className="ad-myreq-link" href={r.bannerImageUrl} target="_blank" rel="noreferrer">
Ver banner
</a>
)}
</div>
<div className="ad-myreq-right">
{r.status === "pending" && (
<button type="button" className="ad-cancel-btn" onClick={() => handleCancelAdRequest(r.id)}>
Cancelar
</button>
)}
</div>
</div>
))}
{myAdRequests.length === 0 && (
<div className="ad-myreq-empty">Você ainda não enviou solicitações de anúncio.</div>
)}
</div>
</div>
</div>
</div>
{/* COLUNA DIREITA */}
<div className="admin-column">
{/* REAJUSTE POR KM */}
{showReajusteKm && (
<div className="modern-card animate-in" style={{ marginBottom: 20, borderTop: "4px solid #6366f1" }}>
<h2 className="card-title">
<TrendingUp size={20} color="#6366f1" /> Reajuste por KM
</h2>
<div style={{ color: "#64748b", fontWeight: 800, fontSize: 13 }}>
Isso recalcula o preço base (sem taxa de embarque) de todas as suas rotas, usando:
<br />
<b>Preço = (KM da rota × Valor por KM) + Taxa fixa</b>
</div>
<div className="input-grid" style={{ marginTop: 12 }}>
<div className="input-group">
<label>VALOR POR KM</label>
<input
type="number"
step="0.10"
value={pricingConfigs.valorPorKm}
onChange={(e) => {
setPricingConfigs({ ...pricingConfigs, valorPorKm: e.target.value });
setPricingMode("auto");
}}
/>
</div>
<div className="input-group">
<label>TAXA FIXA</label>
<input
type="number"
value={pricingConfigs.taxaFixa}
onChange={(e) => {
setPricingConfigs({ ...pricingConfigs, taxaFixa: e.target.value });
setPricingMode("auto");
}}
/>
</div>
</div>
<button
type="button"
onClick={async () => {
const vKm = parseFloat(pricingConfigs.valorPorKm) || 0;
const tFixa = parseFloat(pricingConfigs.taxaFixa) || 0;
if (!vKm) return alert("Defina o valor por KM.");
if (!(await verificarSenha())) return;
setIsCalculating(true);
try {
const batch = writeBatch(db);
myRoutes.forEach((r) => {
const nP = parseFloat(r.distance || 0) * vKm + tFixa;
batch.update(doc(db, "routes", r.id), {
price: Number(nP.toFixed(2)),
updatedAt: serverTimestamp(),
});
});
await batch.commit();
alert("Preços atualizados via KM!");
} finally {
setIsCalculating(false);
}
}}
className="btn-apply"
style={{
width: "100%",
marginTop: 10,
padding: 12,
background: "#6366f1",
color: "white",
border: "none",
borderRadius: 8,
cursor: "pointer",
fontWeight: 900,
}}
>
{isCalculating ? "PROCESSANDO..." : "RECALCULAR TUDO VIA KM"}
</button>
</div>
)}
{/* REAJUSTE GLOBAL */}
{showReajusteGlobal && (
<div className="modern-card animate-in" style={{ marginBottom: 20, borderLeft: "4px solid #f59e0b" }}>
<h2 className="card-title">
<Percent size={20} color="#f59e0b" /> Reajuste global (%)
</h2>
<div style={{ color: "#64748b", fontWeight: 800, fontSize: 13 }}>
Aplica um percentual em <b>todas</b> as suas rotas (no preço base, sem taxa de embarque).
</div>
<div className="input-group" style={{ marginTop: 10 }}>
<label>Porcentagem</label>
<input
type="number"
placeholder="Ex: 10 para aumentar 10% em tudo"
value={globalPercent}
onChange={(e) => setGlobalPercent(e.target.value)}
/>
</div>
<button
type="button"
onClick={async () => {
const perc = parseFloat(globalPercent);
if (!Number.isFinite(perc)) return alert("Digite um percentual válido.");
if (!(await verificarSenha())) return;
setIsCalculating(true);
try {
const batch = writeBatch(db);
myRoutes.forEach((r) => {
const precoAtual = parseFloat(r.price) || 0;
const novoPreco = precoAtual + precoAtual * (perc / 100);
batch.update(doc(db, "routes", r.id), {
price: Number(novoPreco.toFixed(2)),
updatedAt: serverTimestamp(),
});
});
await batch.commit();
alert(`Sucesso! Todas as rotas reajustadas em ${perc}%`);
setGlobalPercent("");
} finally {
setIsCalculating(false);
}
}}
style={{
width: "100%",
marginTop: 10,
padding: 12,
background: "#f59e0b",
color: "white",
border: "none",
borderRadius: 8,
cursor: "pointer",
fontWeight: 900,
}}
>
{isCalculating ? "PROCESSANDO..." : `APLICAR ${globalPercent || "0"}% EM TUDO`}
</button>
</div>
)}
{/* LISTA */}
<div className="list-header">
<h2 className="card-title">Minhas Rotas ({myRoutes.length})</h2>
</div>
<div className="routes-list">
{myRoutes.map((r) => (
<div key={r.id} className="route-item animate-in">
<div className="route-txt">
<strong>
{r.origin?.split(",")[0]} → {r.destination?.split(",")[0]}
</strong>
<div style={{ display: "flex", gap: 10, fontSize: 11, color: "#666", margin: "4px 0" }}>
<span>
<Clock size={12} /> {r.outTime} | {r.returnTime}
</span>
<span>{r.distance} km</span>
{r.hasEmbarkFee ? (
<span style={{ color: "#0ea5e9", fontWeight: 900 }}>
+ taxa R$ {Number(r.embarkFeeValue || 0).toFixed(2)}
</span>
) : null}
</div>
<span className="price-tag">R$ {Number(parseFloat(r.price) || 0).toFixed(2)}</span>
</div>
<div className="route-btns">
<button
type="button"
onClick={() => {
setEditingId(r.id);
setOrigin(r.origin || "");
setDestination(r.destination || "");
setPrice(String(r.price ?? ""));
setOutTime(r.outTime || "");
setReturnTime(r.returnTime || "");
setDriverPhone(r.driverPhone || r.phone || "");
setOriginCompanyPhone(r.originCompanyPhone || "");
setDestCompanyPhone(r.destCompanyPhone || "");
setHasEmbarkFee(!!r.hasEmbarkFee);
setEmbarkFeeValue(String(r.embarkFeeValue ?? ""));
setPricingMode("manual");
// fareOverrides agora são globais da empresa (companies)
setOvCityA("");
setOvCityB("");
setOvPrice("");
window.scrollTo(0, 0);
}}
className="edit-icon"
title="Editar"
>
<Edit3 size={18} />
</button>
<button
type="button"
onClick={async () => {
if (!window.confirm("Excluir?")) return;
if (!(await verificarSenha())) return;
await deleteDoc(doc(db, "routes", r.id));
}}
className="del-icon"
title="Excluir"
>
<Trash2 size={18} />
</button>
</div>
</div>
))}
</div>
</div>
</main>
{/* MODAL — SOLICITAR ANÚNCIO */}
{adModalOpen && (
<div className="ad-modal-overlay" role="dialog" aria-modal="true">
<div className="ad-modal">
<div className="ad-modal-header">
<div className="ad-modal-title">
<Megaphone size={18} />
<span>Solicitar anúncio</span>
</div>
<button type="button" className="ad-modal-close" onClick={() => setAdModalOpen(false)} aria-label="Fechar">
<X size={18} />
</button>
</div>
<div className="ad-modal-body">
<div className="ad-modal-planrow">
<span className={`ad-chip ${adPlan === "destaque" ? "active" : ""}`} onClick={() => setAdPlan("destaque")}>
<Sparkles size={14} /> Destaque
</span>
<span
className={`ad-chip ${adPlan === "premium_rota" ? "active" : ""}`}
onClick={() => {
if (!origin || !destination) return alert("Preencha Origem e Destino primeiro.");
setAdPlan("premium_rota");
}}
>
<Crown size={14} /> Premium por rota
</span>
</div>
{adPlan === "premium_rota" && (
<div className="ad-modal-route">
<div className="ad-route-label">Rota alvo</div>
<div className="ad-route-value">
{origin || "—"} → {destination || "—"}
</div>
<div className="ad-route-hint">O anúncio aparece quando o usuário buscar esse trecho.</div>
</div>
)}
<div className="ad-modal-grid">
<div className="ad-field">
<label>Posicionamento</label>
<select value={adPlacement} onChange={(e) => setAdPlacement(e.target.value)}>
<option value="top">Topo (carrossel)</option>
<option value="side">Laterais (desktop)</option>
<option value="mobile">Mobile (carrossel)</option>
<option value="inline">Inline (no meio das rotas)</option>
</select>
</div>
<div className="ad-field">
<label>Duração (dias)</label>
<select value={adDurationDays} onChange={(e) => setAdDurationDays(Number(e.target.value))}>
<option value={7}>7 dias</option>
<option value={15}>15 dias</option>
<option value={30}>30 dias</option>
</select>
</div>
</div>
<div className="ad-field">
<label>Imagem do banner</label>
<input
type="file"
accept="image/*"
onChange={(e) => {
const files = Array.from(e.target.files || []);
if (files.length > MAX_AD_IMAGES) {
window.alert(`Envie no máximo ${MAX_AD_IMAGES} imagem por solicitação.`);
e.target.value = "";
setAdImageFile(null);
setAdImagePreview("");
return;
}
const f = files[0];
if (!f) {
setAdImageFile(null);
setAdImagePreview("");
return;
}
if (!ACCEPTED_AD_IMAGE_TYPES.includes(f.type)) {
window.alert("Formato inválido. Use PNG ou JPG.");
e.target.value = "";
setAdImageFile(null);
setAdImagePreview("");
return;
}
const maxBytes = MAX_AD_IMAGE_MB * 1024 * 1024;
if (f.size > maxBytes) {
window.alert(`Arquivo muito grande. Máximo ${MAX_AD_IMAGE_MB}MB.`);
e.target.value = "";
setAdImageFile(null);
setAdImagePreview("");
return;
}
setAdImageFile(f);
setAdImagePreview(URL.createObjectURL(f));
}}
/>
<small>Recomendado 16:9 (ex.: 1200×675). PNG/JPG até ~8MB.</small>
{adImagePreview && (
<div className="ad-preview">
<img
src={adImagePreview}
alt="Prévia do banner"
onLoad={(e) => {
try {
URL.revokeObjectURL(e.currentTarget.src);
} catch {}
}}
/>
</div>
)}
</div>
<div className="ad-field">
<label>Link de destino (WhatsApp/Instagram/Site)</label>
<input value={adLinkDestino} onChange={(e) => setAdLinkDestino(e.target.value)} placeholder="https://wa.me/55..." />
<small>Esse link abre quando o usuário tocar no anúncio.</small>
</div>
</div>
<div className="ad-modal-footer">
<button type="button" className="ad-btn ghost" onClick={() => setAdModalOpen(false)}>
Cancelar
</button>
<button type="button" className="ad-btn primary" onClick={submitAdRequest} disabled={adSubmitting}>
{adSubmitting ? "Enviando..." : "Enviar solicitação"}
</button>
</div>
</div>
</div>
)}
</div>
);
}